import React, { useEffect, useState } from 'react';
import { withNamespaces } from 'react-i18next';
import { forceRefresh, startVersionCheck, stopVersionCheck } from '../../utils/versionCheck';

/**
 * Notification de mise à jour disponible
 * S'affiche en bas de l'écran quand une nouvelle version est détectée
 */
const UpdateNotification = ({ t }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') return undefined;

    startVersionCheck(() => {
      setShow(true);
    });

    return stopVersionCheck;
  }, []);

  if (!show) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: '#667eea',
        color: 'white',
        padding: '12px 24px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)',
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        zIndex: 9999,
        animation: 'slideUp 0.3s ease-out'
      }}
    >
      <style>
        {`
          @keyframes slideUp {
            from {
              opacity: 0;
              transform: translateX(-50%) translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateX(-50%) translateY(0);
            }
          }
        `}
      </style>

      <i className="fas fa-sync-alt" style={{ fontSize: '18px' }}></i>

      <span style={{ fontSize: '14px', fontWeight: '500' }}>
        {t('update.available')}
      </span>

      <button
        onClick={forceRefresh}
        style={{
          backgroundColor: 'white',
          color: '#667eea',
          border: 'none',
          padding: '6px 16px',
          borderRadius: '4px',
          cursor: 'pointer',
          fontWeight: '600',
          fontSize: '13px',
          transition: 'transform 0.2s'
        }}
        onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
        onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
      >
        {t('update.button')}
      </button>

    </div>
  );
};

export default withNamespaces('translations')(UpdateNotification);
